<form class="no-padding" [formGroup]="supplierInvoiceItemLinkForm" id="supplierInvoiceItemLinkForm" (ngSubmit)="onSubmit()">
  <div class="grid bgc-neutral-100 p-24 mb-24 ">
    <div class="d-flex flex-column gap-18 g-col-4">
      <div><span class="fc-neutral-800 fw-500">{{'SUPPLIER' | translate | uppercase }}</span></div>
      <div> {{ section()?.supplierName}} </div>
    </div>
    <div class="d-flex flex-column gap-18 g-col-4" >
      <div><span class="fc-neutral-800 fw-500">{{'AMOUNT_TO_ASSIGN' | translate | uppercase }}</span></div>
      <div> {{ supplierInvoiceItem()?.amountToMap | kendoNumber: amountFormat }} </div>
    </div>
    <div class="d-flex flex-column gap-18 g-col-4" >
      <div><span class="fc-neutral-800 fw-500">{{'LINE_TOTAL' | translate | uppercase }}</span></div>
      <div> {{ supplierInvoiceItem()?.lineTotal | kendoNumber: decimalFormat}} </div>
    </div>
  </div>
  <div class="card-body">
    @let corder= co();
    @if(corder) {
    <rc-client-order-item-table class="mb-24" (clientOrderItemSelection)="patchSupplierInvoiceItemForm($event)"
                                [section]="section()!"
                                [selectedOrderItem]="selectedOrderItem()"
                                [supplierInvoiceItem]="supplierInvoiceItem()!"
                                [initialValue]="supplierInvoiceItem()?.articleNumber"
                                [clientOrder]="corder"></rc-client-order-item-table>
    } @else {
      <kendo-loader [type]="'converging-spinner'"></kendo-loader>
    }
  </div>
</form>
<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button kendoButton class="g-start-10 string-button" (click)="close()">
      {{ "CANCEL" | translate | capitalize }}
    </button>
    <button
      [disabled]="supplierInvoiceItemLinkForm.invalid"
      class="g-col-2 g-start-11"
      kendoButton
      type="submit"
      form="supplierInvoiceItemLinkForm"
      [iconClass]="'rc-icon-row-insert-bottom'"
      [themeColor]="'primary'">
      {{ "ASSOCIATE" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
